var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgHoveredEye = function SvgHoveredEye(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5323_146754)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.862549,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#1976D2",
    fillOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 22.8625C20.5304 22.8625 21.0391 22.6518 21.4142 22.2768C21.7893 21.9017 22 21.393 22 20.8625C22 20.3321 21.7893 19.8234 21.4142 19.4483C21.0391 19.0733 20.5304 18.8625 20 18.8625C19.4696 18.8625 18.9609 19.0733 18.5858 19.4483C18.2107 19.8234 18 20.3321 18 20.8625C18 21.393 18.2107 21.9017 18.5858 22.2768C18.9609 22.6518 19.4696 22.8625 20 22.8625Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.458 20.8625C11.732 16.8055 15.522 13.8625 20 13.8625C24.478 13.8625 28.268 16.8055 29.542 20.8625C28.268 24.9195 24.478 27.8625 20 27.8625C15.522 27.8625 11.732 24.9195 10.458 20.8625ZM24 20.8625C24 21.9234 23.5786 22.9408 22.8284 23.691C22.0783 24.4411 21.0609 24.8625 20 24.8625C18.9391 24.8625 17.9217 24.4411 17.1716 23.691C16.4214 22.9408 16 21.9234 16 20.8625C16 19.8017 16.4214 18.7843 17.1716 18.0341C17.9217 17.284 18.9391 16.8625 20 16.8625C21.0609 16.8625 22.0783 17.284 22.8284 18.0341C23.5786 18.7843 24 19.8017 24 20.8625V20.8625Z",
    fill: "#1976D2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5323_146754"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 0.862549)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHoveredEye);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "hovered-eye.640e89d03af06115aa1f7301e3b8f4ba.svg";